import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import {
  makeStyles,
  AppBar,
  Toolbar,
  Button
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  actionBar: {
    top: 'auto',
    bottom: 0,
    //boxShadow: '0px 6px 10px rgba(0, 0, 0, 0.14)',
    backgroundColor: '#fff',
    color: '#000',
  },
  actionToolBar: {
    justifyContent: 'flex-end'
  },
  cancelBtn: {
    marginRight: theme.spacing(4)
  },
}));

const ItemActionBar = props => {
  const classes = useStyles();
  const { t } = useTranslation();

  return(
    <AppBar position="fixed" className={classes.actionBar} component="div">
      <Toolbar className={classes.actionToolBar}>
        <Button variant="outlined" color="primary" className={classes.cancelBtn} onClick={props.cancelChanges}>{t('common:cancelChanges')}</Button>
        <Button variant="contained" color="primary" onClick={props.saveChanges} disabled={props.disabled}>{t('common:saveChanges')}</Button>
      </Toolbar>
    </AppBar>
  )
};

ItemActionBar.propTypes = {
  cancelChanges: PropTypes.func,
  saveChanges: PropTypes.func,
  disabled: PropTypes.bool
}

export default ItemActionBar;
